"use strict";

import Dom from "common/Dom";
import * as handlers from "scripts/components/CartPage/handlers";
var setCheckoutButtonDisabledStatus =
  function setCheckoutButtonDisabledStatus() {
    var checkboxState = $(Dom.checkoutBtnPolicyAcknowledgement).prop("checked");
    $(Dom.cartPageCheckout).attr("disabled", !checkboxState);
  };
export const bindActions = function bindActions() {
  $(document).ready(function () {
    var input = $(Dom.giftMessageInput);
    if (input.length) {
      var maxLength = input.attr("maxlength"),
        currentLength = input.val().length,
        remaining = maxLength - currentLength;
      if (currentLength) {
        $(Dom.giftMessageToggle).prop("checked", true);
        handlers.handleGiftMessageToggle(true);
      }
      handlers.updateCharCount(remaining);
    }
    setCheckoutButtonDisabledStatus();
  });
  $(Dom.giftMessageInput).on("input", function () {
    var maxLength = $(this).attr("maxlength"),
      currentLength = $(this).val().length,
      remaining = maxLength - currentLength;
    handlers.updateCharCount(remaining);
  });
  $(Dom.giftMessageToggle).on("change", function () {
    var toggle = this.checked;
    handlers.handleGiftMessageToggle(toggle);
  });
  $(Dom.cartPageCheckout).on("click", function () {
    var giftMessage = $(Dom.giftMessageInput),
      toggle = $(Dom.giftMessageToggle).is(":checked");
    if (giftMessage.length && toggle) {
      handlers.setNoteAndCheckout(giftMessage.val());
    } else if (giftMessage.length && !toggle) {
      handlers.setNoteAndCheckout("");
    } else {
      window.location.href = "/checkout";
    }
  });
  $(Dom.checkoutBtnPolicyAcknowledgement).on(
    "change",
    setCheckoutButtonDisabledStatus,
  );
};
